var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    d: "M20 7h66c5.51915024 0 10 4.48084976 10 10v66c0 5.51915024-4.48084976 10-10 10H20c-5.51915024 0-10-4.48084976-10-10V17c0-5.51915024 4.48084976-10 10-10z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "200%",
    height: "200%",
    x: "-50%",
    y: "-50%",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 8,
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 9.036
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.12 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "rgb(151,145,104)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M70.20459096 32C54.03286467 32 40.7312033 44.3816914 39.32167524 60.1168086c2.6870597-3.7715 5.9786929-7.4005 10.08803284-11.5725586.30545617-.3135.81136794-.3198086 1.12480355-.0110586.3134356.3055586.31820836.8075.01111156 1.11944141-.61889177.627-1.24725448 1.27775-1.87889845 1.9364414-.36116313.37525-.71434682.74894141-1.06111712 1.11625-.06361185.0680586-.12729826.13619141-.1909101.2058086-5.07820872 5.4118086-8.70870736 10.12217578-11.3449074 15.97261719-.17979854.399 0 .8676914.39934516 1.0465586.10656661.0475.21633992.0696914.32611323.0696914.3038901 0 .595028-.1741914.72702445-.4670586.9386662-2.08205859 2.02841983-4.01375 3.25345118-5.8931914 11.11096794-.2834414 21.2244306-6.4346914 26.52539263-16.2228086.13207101-.2454414.12565763-.5415-.01752495-.7821914-.14474864-.2375-.4041179-.38475-.68406967-.38475h-2.94635439l5.28343708-3.0051914c.16704634-.095.29591066-.2485586.35795644-.4290586C70.42726969 39.53825 71 36.16575 71 32.7916914 71 32.3546914 70.6436842 32 70.20459096 32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.ca23903d1c07acf43a46a1ba523e5fe4.svg";
export { ForwardRef as ReactComponent };